import {gsap} from 'gsap';
import {ScrollToPlugin} from 'gsap/ScrollToPlugin';
import PageComponent from '../../common/component/page-component';

gsap.registerPlugin(ScrollToPlugin);

class ApplicationSections extends PageComponent {

	constructor({element, root, currentClass = 'current', scrollDuration = 0.6}) {
		super({element: element, root: root});
		this.currentClass = currentClass;
		this.scrollDuration = scrollDuration;
	}


	prepare() {
		const sectionElements = this.element.querySelectorAll(this.dataSelector('section'));
		this.currentId = null;
		this.sections = new Map();
		for (const sectionElement of sectionElements) {
			const id = String(this.dataAttr(sectionElement).get('section'));
			this.sections.set(id, sectionElement);
			if (this.classList(sectionElement).contains(this.currentClass)) {
				this.currentId = id;
			}
		}
	}


	clear() {
		this.sections.clear();
	}


	switchTo(newId, scrollToTop = true) {
		return new Promise((resolve) => {
			const current = this.sections.get(this.currentId);
			const next = this.sections.get(newId);
			const height = Math.max(current.getBoundingClientRect().height, next.getBoundingClientRect().height);
			this.element.style.height = height + 'px';
			this.classList(current).remove(this.currentClass);
			this.classList(next).add(this.currentClass);
			if (scrollToTop) {
				gsap.to(window, {duration: this.scrollDuration, delay: 0.2, scrollTo: {y: 0, autoKill: false}});
			}
			this.onTransitionEnd(next).then(() => {
				this.element.style.removeProperty('height');
				this.currentId = newId;
				resolve();
			});
		});
	}

}


export default ApplicationSections;
